import React from "react";
import { connect } from "react-redux";
import { Popup, Button, ValidationGroup } from "devextreme-react";
import moment from "moment";
import validaciones from "../../../../../helpers/validaciones";
import TextField from "../../../../Shared/fields/TextField";
import SwitchField from "../../../../Shared/fields/SwitchField";
import DateField from "../../../../Shared/fields/DateField";
import TagField from "../../../../Shared/fields/TagField";
import RadioGroupfield from "../../../../Shared/fields/RadioGroupField";
import { setAppointment, openCloseModalEditarScheduler, doAddAppointment, doUpdateAppointment, doGetCentros } from "./actions";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalEditarAppointment extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleAdd = this.handleAdd.bind(props);  
  }

  componentDidMount(){
    this.props.dispatch(doGetCentros(null, true));
  }
  
  handleCancel = () => {
    this.props.dispatch(openCloseModalEditarScheduler(false, {}, false));
  }

  handleAdd = (params) => {
    const result = params.validationGroup.validate();
    if (!result.isValid) return;
    if (this.props.isEditAppointment) {
      //this.props.dispatch(doAddAppointment(this.props.appointment));
      this.props.dispatch(doUpdateAppointment(this.props.appointment));
    } else {
      //this.props.dispatch(doUpdateAppointment(this.props.appointment));
      this.props.dispatch(doAddAppointment(this.props.appointment));
    }
  }

  handleChange = (e) => {
    const NewAppointment = { ...this.props.appointment };
    NewAppointment[e.element.id] = e.value;
    if(NewAppointment !== undefined && NewAppointment.repeatOnOff !== undefined && NewAppointment.repeatOnOff === false){
      NewAppointment.Repeat = null;
      NewAppointment.RepeatEndDate = null;
    }
    this.props.dispatch(setAppointment(NewAppointment));
  }

  handleChangeTag = (e) => {
    const NewAppointment = { ...this.props.appointment };
    const newValueList = e.component._selectedItems.map(p => p.Id);
    NewAppointment[e.element.id] = newValueList;
    this.props.dispatch(setAppointment(NewAppointment));
  }

  render() {
    const { appointment } = this.props;
    let centrosActivos = this.props.listaCentros.filter((c) => c.Status === 1);
    return (
      <Popup
        title={validaciones.capitalizeFirstLetter(moment(appointment.startDate).format("dddd DD [de] MMMM"))}
        showCloseButton
        dragEnabled={false}
        className="schedular-modal-edit"
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEditar}
        width={500}
        height={600}
        contentComponent={() => (
          <ValidationGroup>
            {this.props.isLoading ? <LoadingOverlay /> : <div />}
            <TextField
              label="Nombre"
              id="text"
              maxLength={60}
              value={appointment.text}
              onChange={this.handleChange}
            />

            <SwitchField
              label="Todo el día"
              id="allDay"
              switchedOffText="No"
              switchedOnText="Si"
              visible
              value={appointment.allDay}
              onChange={this.handleChange}
            />

            <div className="row">
              <div className="col-6">
                <DateField
                  label="Fecha inicio"
                  id="startDate"
                  value={appointment.startDate}
                  type={appointment.allDay ? "date" : "datetime"}
                  onChange={this.handleChange}
                  max={null}
                />
              </div>
              <div className="col-6">
                <DateField
                  label="Fecha fin"
                  id="endDate"
                  value={appointment.endDate}
                  type={appointment.allDay ? "date" : "datetime"}
                  onChange={this.handleChange}
                  max={null}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <SwitchField
                  label="Repetir"
                  id="repeatOnOff"
                  visible
                  switchedOffText="No"
                  switchedOnText="Si"
                  value={appointment.repeatOnOff}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-8">
                {appointment.repeatOnOff ? (
                  <RadioGroupfield
                    label=""
                    layout="horizontal"
                    id="repeat"
                    dataSource={[
                      { text: "Semanal", value: "0" },
                      { text: "Mensual", value: "1" },
                      { text: "Anual", value: "2" },
                    ]}
                    displayExpr="text"
                    valueExpr="value"
                    onChange={this.handleChange}
                    value={appointment.repeat || "YEARLY"}
                  />
                ) : <div></div>}
              </div>
            </div>

            {appointment.repeatOnOff ? (
              <DateField
                label="Fecha fin de la repetición"
                id="repeatEndDate"
                value={appointment.repeatEndDate}
                onChange={this.handleChange}
                type="date"
                max={null}
              />
            ) : <div></div>}

            <TagField
              label="Centros comprometidos"
              id="centers"
              value={appointment.centers}
              displayExpr="Description"
              valueExpr="Id"
              onChange={this.handleChangeTag}
              items={centrosActivos}
                searchEnabled
                tagTemplate={(i, e) => {
                  if(i.Status === 1){
                    return `<div id='tag${i.Id}' class="dx-tag-content" style="padding-right: 10px">
                    <span>${i.Description || i}</span>
                    </div>`
                  }
                }}
            />

            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
              </div>
              <div>
                <Button text="Guardar" type="success" onClick={this.handleAdd} useSubmitBehavior />
              </div>
            </div>
          </ValidationGroup>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorFeriados.isLoading,
  isOpenModalEditar: state.mantenedorFeriados.isOpenModalEditarScheduler,
  appointment: state.mantenedorFeriados.appointment,
  isEditAppointment: state.mantenedorFeriados.isEditAppointment,
  listaCentros: state.mantenedorFeriados.listaCentros,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalEditarAppointment);

